import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetRedirectUrlQuery } from '../framework/design/components/services/services/relativeUrlsApi';
import { ProgressIndicator } from '../framework/widgets';

export const RedirectPageWrapper = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = queryParams.get('token');
    const { data } = useGetRedirectUrlQuery(tokenFromUrl || '');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRedirectUrl = async () => {
            if (data?.url) {
                try {
                    navigate(data.url || '');
                } catch (error) {
                    console.error('Error fetching redirect URL:', error);
                } finally {
                    setLoading(false);
                }
            } else {
                setLoading(false);
            }
        };

        fetchRedirectUrl();
        // eslint-disable-next-line
    }, [data?.url, tokenFromUrl]);

    if (loading) {
        return <ProgressIndicator />;
    }

    return <></>;
};
